/* Terra — collection/search facets: sort auto-submit + price range sanity */

(() => {
  'use strict';

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.submit();
    });
  });

  // Keep min <= max on price range inputs before submitting
  document.querySelectorAll('.facets').forEach((form) => {
    form.addEventListener('submit', () => {
      const inputs = form.querySelectorAll('.facets__price input[type="number"]');
      if (inputs.length === 2) {
        const [min, max] = inputs;
        if (min.value && max.value && Number(min.value) > Number(max.value)) {
          max.value = min.value;
        }
      }
      // Drop empty fields so URLs stay clean
      form.querySelectorAll('input[type="number"], input[type="checkbox"]').forEach((input) => {
        if (input.type === 'number' && input.value === '') input.disabled = true;
      });
    });
  });
})();
